import { render, staticRenderFns } from "./AddACL.vue?vue&type=template&id=49b06de9&scoped=true"
import script from "./AddACL.vue?vue&type=script&lang=js"
export * from "./AddACL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b06de9",
  null
  
)

export default component.exports